import { connectHook } from 'app/common/components/connect-hook';
import { BranchMerge } from './branch-merge.js';
import { useBranchMerge } from './branch-merge-hook.js';

export default connectHook(BranchMerge, useBranchMerge);
